export type DniWireframePhotoSide = 'left' | 'right' | null | undefined;

const RIGHT_FILE_EXTENSIONS = new Set(['png', 'json', 'svg']);

/**
 * Resuelve la ruta del asset DNI según tema y lado de la foto.
 * PNG/JSON/SVG: añade `-right` cuando photoSide === 'right' (foto embebida; no espejar por CSS).
 * JSON: el tema va por LottieThemeService; no se añade `-dark`.
 * Fallback: cualquier valor distinto de `'right'` (incluido `null`) usa el asset histórico.
 */
export function resolveDniPhotoSideAsset(
	assetPath: string,
	photoSide: DniWireframePhotoSide,
	isDarkMode: boolean,
): string {
	const separator = assetPath.lastIndexOf('.');
	if (separator <= 0) {
		return assetPath;
	}

	const basePath = assetPath.slice(0, separator);
	const extension = assetPath.slice(separator + 1).toLowerCase();
	const rightSuffix = photoSide === 'right' && RIGHT_FILE_EXTENSIONS.has(extension) ? '-right' : '';
	const themeSuffix = isDarkMode && extension !== 'json' ? '-dark' : '';

	return `${basePath}${rightSuffix}${themeSuffix}.${extension}`;
}
